module.exports = __webpack_public_path__ + "img/Foto_Press_Release_DAB_x_Jabar_Telematika.40f54caf.jpeg";